/**
 * Env-Badge nach dem Muster RMNC-Leitstand: farbiges Badge je App-Stage.
 * Farben identisch zum Leitstand (dev orange, stage blau, prod gruen "Live").
 */

const ENVS: Record<string, { label: string; className: string }> = {
  dev: { label: "Dev", className: "bg-[#e67e22] text-white" },
  stage: { label: "Stage", className: "bg-[#2980b9] text-white" },
  stag: { label: "Stage", className: "bg-[#2980b9] text-white" },
  staging: { label: "Stage", className: "bg-[#2980b9] text-white" },
  prod: { label: "Live", className: "bg-[#27ae60] text-white" },
  live: { label: "Live", className: "bg-[#27ae60] text-white" },
  local: { label: "Local", className: "bg-[#7f8c8d] text-white" },
}

export function EnvBadge() {
  const env = (import.meta.env.VITE_ENV || "local").toLowerCase()
  const cfg = ENVS[env] ?? ENVS.local
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide ${cfg.className}`}
      title={`Umgebung: ${cfg.label}`}
    >
      {cfg.label}
    </span>
  )
}
